import { render, staticRenderFns } from "./add-saksi.vue?vue&type=template&id=a9913d76&"
import script from "./add-saksi.vue?vue&type=script&lang=js&"
export * from "./add-saksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports